import { formatNumber } from "@/lib/utils";

export function formatHours(h: number): string {
  if (!isFinite(h)) return "∞";
  if (h < 1) return `${Math.round(h * 60)} min`;
  if (h < 24) return `${formatNumber(h, 1)} h`;
  return `${formatNumber(h / 24, 1)} d`;
}

export function formatDays(d: number): string {
  if (!isFinite(d)) return "∞";
  if (d < 1) return `${formatNumber(d * 24, 1)} h`;
  return `${formatNumber(d, 1)} d`;
}

export function formatWh(wh: number): string {
  if (Math.abs(wh) >= 1000) return `${formatNumber(wh / 1000, 2)} kWh`;
  return `${Math.round(wh)} Wh`;
}

export function formatW(w: number): string {
  if (Math.abs(w) >= 1000) return `${formatNumber(w / 1000, 2)} kW`;
  if (w !== 0 && Math.abs(w) < 0.1) return `${Number((w * 1000).toPrecision(3))} mW`;
  return `${Math.round(w)} W`;
}

export function splitValueUnit(s: string): { value: string; unit: string } {
  if (s === "∞") return { value: "∞", unit: "" };
  const m = s.match(/^(.*?)\s+([a-zA-Z%]+)$/);
  if (m) return { value: m[1], unit: m[2] };
  return { value: s, unit: "" };
}
